import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import DashboardList from "../../Components/Layouts/DashboardList";
import {getDeletedList, permanentDeleteEntity, restoretDeleteEntity} from "../../Redux/Testimonial/actions"; 

function DeletedList({ useAuth, getList, list, onDelete, onRestore}) {
  const tableConfig = {
    title: "Deleted Testimonial(s)",
    filterOptionTitle: "Category Type",
    filterOptions: [
      "category",
    ],
    defaultFilterValue: 'admin',
    applyFilter: false,
    tableColumns: [
      {name: "Order", selector: 'order', width: '3%'},
      {name: "Status", selector: 'status', width: '3%'},
      {name: "Name", selector: 'full_name', width: '70%'},
      {name: "Modified Date", selector: 'updated_at', width: '17%'},
      {name: "ID", selector: 'id', width: '5%'}
    ],
    filterByColumn: 'full_name',
    searchByColumn: 'full_name',
    updatePath: "/testimonial/update", 
    addPath: "/testimonial/add",
    restorePath: "/testimonials",
    noDataMessage: "No testimonial exists",
    updateLinkColumn: 'full_name',
    deleteBtnText: 'Permanent Delete',
    deleteItemsByIdList: (idList) => {
      onDelete(idList)
    },
    restoreItemsByIdList: (idList) => {
      onRestore(idList)
    },
  }
  return (
    <DashboardList
      useAuth={useAuth}
      getList={getList}
      dataToList={list}
      tableConfig={tableConfig}
    />
  );
}


const mapStateToProps = (state) => {
  return {
    list: state.testimonial,
    loginData: state.loginData, 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getList: (tokenData) => dispatch(getDeletedList(tokenData)),
    onDelete: (idList) => dispatch(permanentDeleteEntity(idList)),
    onRestore: (idList) => dispatch(restoretDeleteEntity(idList))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeletedList);
